"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Parallax effect for the hero. Returns a ref to attach to the hero
 * container and the current Y offset (`scrollY * 0.4` while the hero
 * is still in view). Stops updating once the hero scrolls past — no
 * point repainting a transform that won't be visible.
 */
export function useParallaxScroll() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        if (rect.bottom > 0) {
          setScrollY(window.scrollY * 0.4);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return { heroRef, scrollY };
}
